import checkout from "./form";

const {
  formField: {
    fullName,
    chiefAccountant,
    signer,
    timeSign,

    taxpayersName,
    taxpayersId,

    bctc,
    htldl,
    auditOpinion,
  },
} = checkout;

const initialValues = {
  [fullName.name]: "",
  [signer.name]: "",
  [timeSign.name]: "",
  [chiefAccountant.name]: "",

  [taxpayersName.name]: "",
  [taxpayersId.name]: "",
  [auditOpinion.name]: "",

  [bctc.name]: false,
  [htldl.name]: false,
};

export default initialValues;
